import { Property, PROPERTY_TYPE } from "components/pivotGrid/types"
import { getMonthName } from "components/pivotGrid/utils/utils"
import { buildTreeItems } from "components/pivotGrid/utils/items"


/** Restituisce la struttura delle PROPERTY (rows, cols, values) da visualizzare e gli ITEMS colonna e riga 
 * in base alle PROPERTIES in LIBRARY e ai DATA usati */
export function getStructsByProperties(colProperties: Property[], rowProperties: Property[], valProperties: Property[], data: any[]) {

	clearTempProperties(data)

	// PREPARAZIONE PROPRIETA DATE
	colProperties = setupProperties(colProperties, data)
	rowProperties = setupProperties(rowProperties, data)

	// elimino quelli invisibili
	valProperties = valProperties.filter(prop => prop.visible)

	// costruzione delle strutture ad albero per righe e colonne
	// questa va fatta se cambiano i dati
	const rows = buildTreeItems(data, rowProperties)
	const cols = buildTreeItems(data, colProperties)

	return { rowProperties, colProperties, valProperties, rows, cols }
}
export type TemplateStructs = ReturnType<typeof getStructsByProperties>;

/** costuisce, eventualmente ci fossero type=DATE, le DATE temporanee  */
function setupProperties(props: Property[], data: any[]): Property[] {
	return props.reduce((acc, prop) => {

		if (!prop.visible || prop.name.startsWith("*")) return acc

		if (prop.type == PROPERTY_TYPE.DATE) {
			acc.push({
				name: `*${prop.name}_year`, label: `${prop.label} YEAR`, visible: true, fnGroup: prop.fnGroup, sort: prop.sort,
			})
			acc.push({
				name: `*${prop.name}_month`, label: `${prop.label} MONTH`, visible: true, fnGroup: prop.fnGroup, sort: prop.sort, render: getMonthName,
			})
			acc.push({
				name: `*${prop.name}_day`, label: `${prop.label} DAY`, visible: true, fnGroup: prop.fnGroup, sort: prop.sort,
			})
			explodeDate(data, prop);

		} else {
			acc.push(prop)
		}

		return acc
	}, [])
}

// DATA: elimino tutti i campi temporanei precedenti
export function clearTempProperties(data: any[]) {
	for (const item of data) {
		for (const key in item) {
			if (key.startsWith('*')) delete item[key]
		}
	}
}

/**
 * dato un array di dati (normalizzati) 
 * aggiunge le proprietà day, month, year
 * presa da una delle proprietà dei dati
 */
function explodeDate(data: any[], property?: Property) {
	const propName = property?.name ?? "date"
	for (const item of data) {
		// for (const key in item) {
		// 	if (key.startsWith('*')) delete item[key]
		// }
		let value = item[propName]
		if (!!property.render) value = property.render(value)
		if (value == null) return
		const [year, month, day] = value.split('-') ?? []
		item[`*${propName}_day`] = parseInt(day)
		item[`*${propName}_month`] = parseInt(month)
		item[`*${propName}_year`] = parseInt(year)
	}
}
